export type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

const SESSION_KEYS = ['asset.token', 'asset.bookId', 'asset.session'] as const;
const SMARTWORKER_LAUNCH_PATHS = ['/auth/smartworker/callback', '/auth/smartworker/launch'] as const;

export function isSmartWorkerLaunchPath(pathname: string) {
  const normalized = pathname.replace(/\/+$/u, '') || '/';
  return SMARTWORKER_LAUNCH_PATHS.some((path) => normalized === path || normalized.endsWith(path));
}

export function clearStoredAssetSession(storage: StorageLike) {
  for (const key of SESSION_KEYS) storage.removeItem(key);
}

export function isolateSmartWorkerLaunchSession(pathname: string, storage: StorageLike) {
  const smartWorkerLaunch = isSmartWorkerLaunchPath(pathname);
  if (smartWorkerLaunch) clearStoredAssetSession(storage);
  return smartWorkerLaunch;
}
